<h6 class="px-20 pt-20">
  {{ data?.repairerSiteId ? 'Access ' + data?.repairerSiteName : 'Exit ' + data?.repairerSiteName }}
</h6>
<div mat-dialog-content class="subtitle-2 py-10!">
  <div>
    {{
      data?.repairerSiteId
        ? 'You will be granted access to ' + data.repairerSiteName
        : 'You will exit ' + data.repairerSiteName + ' and return to the administration page.'
    }}
  </div>
</div>
<mat-divider class="mx-20! -mb-10!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    cdkFocusInitial
    (click)="data?.repairerSiteId ? grantAccessRepairerSite() : revokeAccessRepairerSite()">
    OK
  </button>
</mat-dialog-actions>
